import { useId } from 'react';
import { SelectableValue, TabNavigationProps } from './types';
import { TabList } from './TabList';

export function TabNavigation<Value extends SelectableValue>({ ariaLabel, className, items, onChange, value }: TabNavigationProps<Value>) {
  const generatedId = useId();

  return (
    <div className={['ui-tabs__list', className].filter(Boolean).join(' ')}>
      <TabList ariaLabel={ariaLabel} generatedId={generatedId} items={items} onChange={onChange} value={value} isStandalone />
    </div>
  );
}

